/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { SuccessBodyAiTutorTemplateDto } from '../_model/successBodyAiTutorTemplateDto';
import type { SuccessBodyListAiTutorTemplateListDto } from '../_model/successBodyListAiTutorTemplateListDto';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAllAiTutorTemplates = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListAiTutorTemplateListDto>(
    { url: `/ai-tutor-templates`, method: 'GET', signal },
    options,
  );
};

export const getGetAllAiTutorTemplatesQueryKey = () => {
  return [`/ai-tutor-templates`] as const;
};

export const getGetAllAiTutorTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllAiTutorTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllAiTutorTemplates>>
  > = ({ signal }) => getAllAiTutorTemplates(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllAiTutorTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllAiTutorTemplates>>
>;
export type GetAllAiTutorTemplatesQueryError = ErrorType<unknown>;

export function useGetAllAiTutorTemplates<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllAiTutorTemplates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllAiTutorTemplates<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAllAiTutorTemplates>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllAiTutorTemplates<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAllAiTutorTemplates<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllAiTutorTemplatesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAllAiTutorTemplatesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllAiTutorTemplatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllAiTutorTemplates>>
  > = ({ signal }) => getAllAiTutorTemplates(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllAiTutorTemplatesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllAiTutorTemplates>>
>;
export type GetAllAiTutorTemplatesSuspenseQueryError = ErrorType<unknown>;

export function useGetAllAiTutorTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllAiTutorTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAllAiTutorTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetAllAiTutorTemplatesSuspense<
  TData = Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllAiTutorTemplates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetAllAiTutorTemplatesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAiTutorTemplate = (
  id: string,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyAiTutorTemplateDto>(
    { url: `/ai-tutor-templates/${id}`, method: 'GET', signal },
    options,
  );
};

export const getGetAiTutorTemplateQueryKey = (id: string) => {
  return [`/ai-tutor-templates/${id}`] as const;
};

export const getGetAiTutorTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiTutorTemplateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiTutorTemplate>>
  > = ({ signal }) => getAiTutorTemplate(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiTutorTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiTutorTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiTutorTemplate>>
>;
export type GetAiTutorTemplateQueryError = ErrorType<unknown>;

export function useGetAiTutorTemplate<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTutorTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAiTutorTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiTutorTemplate<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTutorTemplate>>,
          TError,
          Awaited<ReturnType<typeof getAiTutorTemplate>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiTutorTemplate<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useGetAiTutorTemplate<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAiTutorTemplateQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAiTutorTemplateSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAiTutorTemplateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiTutorTemplate>>
  > = ({ signal }) => getAiTutorTemplate(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAiTutorTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiTutorTemplateSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiTutorTemplate>>
>;
export type GetAiTutorTemplateSuspenseQueryError = ErrorType<unknown>;

export function useGetAiTutorTemplateSuspense<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiTutorTemplateSuspense<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiTutorTemplateSuspense<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useGetAiTutorTemplateSuspense<
  TData = Awaited<ReturnType<typeof getAiTutorTemplate>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAiTutorTemplate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetAiTutorTemplateSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
